import React, { useEffect, useRef, useState } from "react";
import "./styles.scss";
import { Container, Row, Col, ListGroup, Form } from "react-bootstrap";
import LogoImg from "../../assets/images/logo-full.png";
import { CiHeart, CiMenuFries, CiUser } from "react-icons/ci";
import { Link, useNavigate } from "react-router-dom";
import {
  IoBookOutline,
  IoChevronDown,
  IoChevronForwardOutline,
  IoChevronUpCircleSharp,
  IoBarChartOutline,
} from "react-icons/io5";
import Para from "../Para";
import { CiSearch } from "react-icons/ci";
import { IoBagOutline } from "react-icons/io5";
import { FaLanguage, FaRegBell, FaRegUserCircle } from "react-icons/fa";
import { FaChalkboardUser } from "react-icons/fa6";
import ContactUsModal from "../Modals/ContactUsModal";
import LoginModal from "../Modals/LoginModal";
import RegisterModal from "../Modals/RegisterModal";
import { useDispatch, useSelector } from "react-redux";
import ApiService from "../../services/ApiService";
import { fetchCartItems } from "../../store2/features/cartSlice";
import { toast } from "react-toastify";
import { callAlert, getUserDetails } from "../../services/CommonService";
import { IoClose } from "react-icons/io5";
import { GoGift } from "react-icons/go";

export default function NavbarHeader() {
  const [showCoursesMenu, setShowCoursesMenu] = useState(false);
  const [activeCategory, setActiveCategory] = useState(null);

  const [mobileOpen, setMobileOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [userDetails, setUserDetails] = useState(false);
  const navigate = useNavigate();
  const cartItems = useSelector((state) => state.cart.items);
  const cartItemsCount = useSelector((state) => state.cart.cartItems);

  const dispatch = useDispatch();
  const [isMobile, setIsMobile] = useState(false);
  const [isProfileMenuOpen, setIsProfileMenuOpen] = useState(false);

  const [showMobileMenu, setShowMobileMenu] = useState(false);

  const toggleMobileProfileMenu = () => {
    setShowMobileMenu((prev) => !prev);
  };

  const toggleProfileMenu = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsProfileMenuOpen(!isProfileMenuOpen);
  };

  const [openMenus, setOpenMenus] = useState({
    main: false,
    categories: {},
  });

  const toggleMenu = (menuKey, categoryIndex = null) => {
    if (menuKey === "main") {
      setOpenMenus((prev) => ({
        ...prev,
        main: !prev.main,
        categories: {}, // Close all categories when main closes
      }));
    } else if (categoryIndex !== null) {
      setOpenMenus((prev) => ({
        ...prev,
        categories: {
          ...prev.categories,
          [categoryIndex]: !prev.categories[categoryIndex],
        },
      }));
    }
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!e.target.closest(".menu-nav-wrap")) {
        setMenuOpen(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768); // mobile breakpoint
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    // Fetch cart items on component mount
    if (userDetails) {
      dispatch(fetchCartItems());
    }
  }, [dispatch]);

  // const [cartItemsCount, setCartItemsCount] = useState(cartItems.cartResponseWOList ? cartItems.cartResponseWOList.length : 0);
  // const [cartItemsCount, setCartItemsCount] = useState(cartItems.length);

  // useEffect(() => {
  //   setCartItemsCount(cart)
  //   console.log("From Nav bar cart count" + cart)
  // }, [cart])

  // let cartItemsCount = cartItems.cartResponseWOList ? cartItems.cartResponseWOList.length : 0;

  const softLogOut = () => {
    localStorage.setItem("userDetails", "");
    navigate("login");
    window.location.reload();
  };
  const logOut = () => {
    ApiService.getRequest(`/users/logout`, true)
      .then((res) => {
        if (res.data?.resultCode === 1) {
          softLogOut();
        } else {
          callAlert("", res.data?.message);
        }
      })
      .catch((error) => {
        callAlert("", error?.error?.message);
      });
  };

  useEffect(() => {
    // setCartItemsCount(cartItems.cartResponseWOList ? cartItems.cartResponseWOList.length : 0)

    let userDetailss = localStorage.getItem("userDetails");
    if (userDetailss) {
      setUserDetails(JSON.parse(userDetailss));
    }
  }, []);

  const [category, setCategory] = useState();
  const [subCategory, setSubCategory] = useState([]);

  const fetchSubCategory = async () => {
    try {
      const response = await ApiService.publicGetRequest(
        "/additional/findallsubcategory",
      );
      setSubCategory(response.data.data);
    } catch (error) {
      console.error("Error fetching sub category:", error);
    }
  };
  const fetchAllCategory = async () => {
    try {
      const response = await ApiService.publicGetRequest(
        "/additional/findallcategory",
      );
      setCategory(response.data.data);
    } catch (error) {
      console.error("Error fetching sub category:", error);
    }
  };

  useEffect(() => {
    fetchAllCategory();
    fetchSubCategory();
  }, []);

  // const notify = () => toast.success(
  //   <>
  //     {cartItemsCount?.cartItemsCount} <strong>added to cart</strong>
  //   </>);

  const initials =
    userDetails?.firstName ?
      `${userDetails.firstName.charAt(0).toUpperCase()}`
    : "User";

  // const categories = [
  //   {
  //     name: "CBSE", courses: [
  //       "CBSE Class 12",
  //       "CBSE Class 11",
  //       "CBSE Class 10",
  //       "CBSE Class 9",
  //       "CBSE Class 8",
  //       "CBSE Class 7"
  //     ]
  //   },
  //   {
  //     name: "ICSE", courses: [
  //       "ICSE Class 12",
  //       "ICSE Class 11",
  //       "ICSE Class 10",
  //       "ICSE Class 9",
  //       "ICSE Class 8",
  //       "ICSE Class 7"
  //     ]
  //   },
  // ];

  // useEffect(() => {
  //   if (cartItems.length > 0) {
  //     notify();
  //   }
  // }, [cartItems])

  const [selectedLang, setSelectedLang] = useState("en");
  const selectRef = useRef(null);

  useEffect(() => {
    // Optional: Retrieve the saved language from localStorage or any other source
    const savedLang = localStorage.getItem("selectedLang") || "en";
    setSelectedLang(savedLang);

    // Set the value in the dropdown
    if (selectRef.current) {
      selectRef.current.value = savedLang;
    }
  }, []);

  const handleLanguageChange = (e) => {
    const theLang = e.target.value;
    setSelectedLang(theLang);
    localStorage.setItem("selectedLang", theLang); // Save the selected language

    const combo = document.querySelector(".goog-te-combo");
    if (combo) {
      combo.value = theLang;
      const event = new Event("change", { bubbles: true });
      combo.dispatchEvent(event); // Dispatch event to update Google Translate
    }

    window.location = `#googtrans(${theLang}|${theLang})`;
    window.location.reload();
  };
  const userDetailss = getUserDetails();

  function formatReadableDate(dateStr) {
    const parsedDate = new Date(dateStr);
    if (isNaN(parsedDate)) return "Invalid date";

    const options = { day: "2-digit", month: "short", year: "numeric" };
    return parsedDate.toLocaleDateString("en-GB", options); // e.g. "24 Jun 2025"
  }
  function isTodayOrFuture(dateStr) {
    // Convert to ISO-friendly format
    const isoDateStr = new Date(dateStr).toISOString().split("T")[0]; // yyyy-mm-dd
    const inputDate = new Date(isoDateStr);

    if (isNaN(inputDate)) return false;

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    inputDate.setHours(0, 0, 0, 0);
    return inputDate >= today;
  }

  return (
    category && (
      <>
        {userDetailss && userDetailss ?
          <>
            {userDetailss["mode"] == "TR" ?
              <>
                {isTodayOrFuture(userDetailss["trialExpiry"]) ?
                  <div class="container-fluid container-header  ">
                    <div class="d-flex justify-content-center align-items-center container ">
                      <div class="    card-header text-center">
                        <h3>
                          {" "}
                          <GoGift /> You are on a 7 day trial. Trial ends on{" "}
                          {formatReadableDate(userDetailss["trialExpiry"])}.
                          Enjoy learning! <GoGift />{" "}
                        </h3>
                        <span> </span>
                      </div>
                    </div>
                  </div>
                : <div class="container-fluid container-header container-header-red">
                    <div class="d-flex justify-content-center align-items-center container ">
                      <div class="    card-header text-center">
                        <h3>
                          {" "}
                          <GoGift /> Your 7-day trial has ended.{" "}
                          <Link to="/" className="cart-link">
                            Subscribe now{" "}
                          </Link>{" "}
                          to keep learning! <GoGift />{" "}
                        </h3>
                        <span> </span>
                      </div>
                    </div>
                  </div>
                }
              </>
            : ""}{" "}
          </>
        : ""}

        <header className="" id="navbarHeader">
          <div className="navbarWrapper px-3">
            {/* for modals */}
            <ContactUsModal />
            <LoginModal />
            <RegisterModal />

            <Container>
              <Row>
                <Col sm={12} className="pt-1">
                  {/*  */}

                  <div className="mobile-nav-toggler">
                    <div className="icon-wrapper">
                      {/* Cart icon should always show now */}
                      <div className="cart-icon-wrapper">
                        <Link to="/cart" className="cart-link">
                          <IoBagOutline className="cart-icon" />
                          <span className="cart-count-badge">
                            {cartItemsCount}
                          </span>
                        </Link>
                      </div>

                      {/* Hamburger menu toggle */}
                      <div
                        className="menu-icon-wrapper"
                        onClick={() => setMobileOpen(!mobileOpen)}
                      >
                        {mobileOpen ?
                          <IoClose className="menu-icon" />
                        : <CiMenuFries className="menu-icon" />}
                      </div>
                    </div>
                  </div>

                  <div className="logo mobile-logo me-auto mb-3  rel">
                    <Link to="/">
                      <img src={LogoImg} alt="logo" />
                      <span
                        className="text-white logoBottom"
                        style={{ marginLeft: "-45px" }}
                      >
                        Developing Digital Minds
                      </span>
                    </Link>
                  </div>
                  <div className="menu-wrap">
                    <nav
                      className={`menu-nav ${mobileOpen ? "open" : ""} ${
                        userDetails ? "logged-in" : "logged-out"
                      }`}
                      style={{ height: "102%" }}
                    >
                      <div className="logo desktop-logo me-auto mb-3  rel">
                        <Link to="/">
                          <img src={LogoImg} alt="logo" />
                          <span className="text-white logoBottom">
                            Developing Digital Minds
                          </span>
                        </Link>
                      </div>{" "}
                      {userDetails && (
                        <div className="mobile-profile-wrapper">
                          <div className="menu-nav-wrap">
                            <ul className="navigation">
                              <li>
                                <div
                                  className="profile-container"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    toggleMenu("profile");
                                  }}
                                  style={{
                                    display: "flex",
                                    flexDirection: "column", // <-- vertical alignment
                                    alignItems: "center", // <-- center horizontally
                                    justifyContent: "center", // <-- center vertically (optional)
                                    gap: "8px",
                                    cursor: "pointer",
                                    textAlign: "center", // <-- center text inside divs
                                    padding: "16px",
                                    marginLeft: "30px", // <-- some padding for breathing space
                                  }}
                                >
                                  <div className="profile-picture">
                                    <span>{initials}</span>
                                    {/* If you have an actual image, replace span with <img src="..." /> */}
                                  </div>
                                  <div className="profile-text">
                                    <strong>
                                      {userDetails.firstName}{" "}
                                      {userDetails.lastName}
                                    </strong>
                                  </div>
                                  <div className="profile-email">
                                    <span>{userDetails.email}</span>
                                  </div>
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>
                      )}
                      <div
                        className="menu-nav-wrap"
                        style={{
                          marginTop: window.innerWidth >= 768 ? "20px" : "0",
                        }}
                      >
                        <ul className="navigation">
                          {/* after Login menu  */}
                          <div
                            className={`menu-title ${
                              userDetails ? "logged-in-title" : (
                                "logged-out-title"
                              )
                            }`}
                          >
                            <h3>{userDetails ? "" : "Main Menu"}</h3>
                          </div>

                          {userDetails && (
                            <>
                              <li className="menu-item">
                                <Link
                                  to="/user/dashboard"
                                  className="menu-link"
                                >
                                  <IoBarChartOutline className="menu-icon" />
                                  Dashboard
                                  {/* <span className="arrow">›</span> */}
                                </Link>
                              </li>
                              <li className="menu-item">
                                <Link
                                  to="/user/mylearning"
                                  className="menu-link"
                                >
                                  <IoBookOutline className="menu-icon" />
                                  My Learning
                                  {/* <span className="arrow">›</span> */}
                                </Link>
                              </li>
                              {/* <li className="menu-item">
                              <Link to="/wishlist" className="menu-link">
                                <CiHeart className="menu-icon" />
                                Wishlist
                                <span className="arrow">›</span>
                              </Link>
                            </li> */}
                              {/* <li>
                             
                            <Link to="/user/profile">
                              <CiUser className="dawnarrow" /> Profile 
                            </Link> 
                          </li> */}
                              {/*   <li> 
                            <Link to="/notification">
                              <FaRegBell className="dawnarrow" /> Notification 
                            </Link> 
                          </li> */}
                            </>
                          )}

                          {/* after Login menu  */}

                          {!userDetails && (
                            <>
                              <li>
                                <Link
                                  to="/about-us"
                                  onClick={() => setMobileOpen(false)}
                                >
                                  About us
                                </Link>
                              </li>

                              <li>
                                <Link
                                  to="/summary"
                                  onClick={() => setMobileOpen(false)}
                                >
                                  Our Mitr's
                                </Link>
                              </li>
                            </>
                          )}

                          <li className="d-none d-md-block shift-up">
                            <Link to="#">
                              <FaChalkboardUser />
                              Courses <IoChevronDown className="dawnarrow" />
                            </Link>

                            <ul className="sub-menu">
                              {category.map((currentCategory, index) => (
                                <li key={index}>
                                  <Link
                                    to={`/courses/${currentCategory.id}`}
                                    className="courses"
                                  >
                                    {currentCategory.name !== "Other" ? currentCategory.name : "Python"} Courses
                                    <IoChevronForwardOutline />
                                  </Link>
                                  <ul className="sub-menu">
                                    {subCategory
                                      .filter(
                                        (subcategory) =>
                                          subcategory.categoryId ===
                                          currentCategory.id,
                                      )
                                      .map((subcategory, subIndex) => (
                                        <li
                                          className={
                                            subIndex === 0 ? "active" : ""
                                          }
                                          key={subIndex}
                                        >
                                          
                                          <Link
                                            to={`/courses/${
                                              currentCategory.id
                                            }/${encodeURIComponent(
                                              subcategory.id,
                                            )}`}
                                          >
                                            {subcategory.name}
                                          </Link>
                                        </li>
                                      ))}
                                  </ul>
                                </li>
                              ))}
                            </ul>
                          </li>
                          <li
                            className=" d-block d-md-none mobile-courses-trigger "
                            onClick={() => setShowCoursesMenu(true)}
                          >
                            <Link to="#">
                              <FaChalkboardUser />
                              Courses <IoChevronDown className="dawnarrow" />
                            </Link>
                          </li>

                          {showCoursesMenu && (
                            <div className=" mobile-courses-drawer ">
                              <div className="drawer-header">
                                <button
                                  className="close-drawer"
                                  onClick={() => setShowCoursesMenu(false)}
                                >
                                  ←
                                </button>
                                <h3>Explore Courses</h3>
                              </div>
                              <div className="drawer-content">
                                {category.map((currentCategory, index) => {
                                  const isActive =
                                    activeCategory === currentCategory.id;

                                  return (
                                    <div
                                      key={index}
                                      className="accordion-section"
                                    >
                                      <button
                                        className="accordion-toggle"
                                        onClick={() =>
                                          setActiveCategory((prev) =>
                                            prev === currentCategory.id ?
                                              null
                                            : currentCategory.id,
                                          )
                                        }
                                      >
                                        {currentCategory.name}
                                        <IoChevronDown
                                          className={isActive ? "rotate" : ""}
                                        />
                                      </button>
                                      {isActive && (
                                        <ul className="accordion-content">
                                          {subCategory
                                            .filter(
                                              (sub) =>
                                                sub.categoryId ===
                                                currentCategory.id,
                                            )
                                            .map((sub, subIndex) => (
                                              <li key={subIndex}>
                                                <Link
                                                  to={`/courses/${
                                                    currentCategory.id
                                                  }/${encodeURIComponent(
                                                    sub.id,
                                                  )}`}
                                                >
                                                  {sub.name}
                                                </Link>
                                              </li>
                                            ))}
                                        </ul>
                                      )}
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          )}

                          {!userDetails && (
                            <>
                              {/* <li>
                            <Link to="">
                              Join mitr-Z 
                              <IoChevronDown className="dawnarrow" />
                            </Link>
                            <ul className="sub-menu">
                              <li>
                                <Link to="/how-to-become-mitra">
                                  How to become a Mitr 
                                </Link>
                              </li>
                            
                            </ul>
                          </li> */}

                              <li>
                                <Link
                                  to="/blog"
                                  onClick={() => setMobileOpen(false)}
                                >
                                  Blog
                                </Link>
                              </li>
                              <li>
                                <Link
                                  to="/contact-us"
                                  onClick={() => setMobileOpen(false)}
                                >
                                  Contact Us
                                </Link>
                              </li>
                            </>
                          )}
                        </ul>
                      </div>
                      <hr className="demo-divider" />
                      {/* <div className="menu-search">
                    <form action="#" className="menu-search-form">

                      <div className="input-grp">
                        <input
                          type="text"
                          placeholder="Search course . . ."
                        />
                        <button type="submit">
                          <CiSearch />
                        </button>
                      </div>
                    </form>
               


                  </div> */}
                      <div className="menu-action ">
                        <ul className="list-wrap">
                          {/* Show cart icon only when the user is logged in */}
                          {userDetails && (
                            <li className="mini-cart-icon">
                              <Link to={"/cart"} className="cart-count">
                                <IoBagOutline className="cart-icons" />
                                <span className="mini-cart-count">
                                  {cartItemsCount}
                                </span>
                              </Link>
                            </li>
                          )}

                          {/* Show login and signup buttons only when the user is logged out */}
                          {!userDetails && (
                            <>
                              <li className="header-btn login-btn">
                                <Link
                                  onClick={() => setMobileOpen(false)}
                                  to={"/login"}
                                  className="btn btn-link"
                                >
                                  Log in
                                </Link>
                              </li>
                              <li className="header-btn signup-btn">
                                <Link
                                  onClick={() => setMobileOpen(false)}
                                  to={"/register"}
                                  className="btn"
                                >
                                  Sign Up
                                </Link>
                              </li>
                            </>
                          )}
                        </ul>
                      </div>
                      {userDetails && (
                        <>
                          <div className="menu-action">
                            <ul className="list-wrap">
                              {/* <li className="mini-cart-icon">
                            <Link to={"/cart"} className="cart-count">
                              <IoBagOutline className="cart-icons" />
                              <span className="mini-cart-count">
                                {cartItemsCount}
                              </span>
                            </Link>
                          </li> */}
                            </ul>
                          </div>
                          <div className="desktop-wrapper">
                            <div className="menu-nav-wrap">
                              <ul className="navigation">
                                <li>
                                  <div
                                    className="profile-container"
                                    style={{ display: "inline" }}
                                    onClick={(e) => {
                                      e.preventDefault();
                                      e.stopPropagation();
                                      toggleMenu("profile");
                                    }}
                                  >
                                    <div className="profile-text">
                                      <strong style={{ fontWeight: "normal" }}>
                                        Hi, {userDetails.firstName}{" "}
                                        {userDetails.lastName}
                                        <IoChevronDown
                                          className={`dawnarrow ${
                                            openMenus.profile ? "rotate" : ""
                                          }`}
                                        />
                                      </strong>
                                    </div>
                                  </div>

                                  <ul
                                    className={`sub-menu ${
                                      openMenus.profile ? "open" : ""
                                    }`}
                                  >
                                    {/*  <li className="active">
                                <Link to="">Notification Setting</Link>
                              </li> */}
                                    {/*  <li className="active">
                              <Link to="">Message</Link>
                            </li> */}
                                    {/*   <li className="active">
                              <Link to="">Account Setting</Link>
                            </li> */}
                                    {/*    <li className="active">
                              <Link to="">Payment Method</Link>
                            </li>
                            <li className="active">
                              <Link to="">Subscriptions</Link>
                            </li>
                            <li className="active">
                              <Link to="">Purchase Histoy</Link>
                            </li> */}
                                    <li className="active">
                                      <Link to="/user/profile">
                                        Edit Profile
                                      </Link>
                                    </li>
                                    <li className="active">
                                      <Link
                                        to="/login"
                                        onClick={() => logOut()}
                                      >
                                        Log Out
                                      </Link>
                                    </li>
                                  </ul>
                                </li>
                              </ul>
                            </div>
                          </div>

                          {/* </div> */}
                          <div className="mobile-profile-actions">
                            {/* <button className="profile-btn" onClick={() => navigate("/user/profile")}>
    Edit Profile
  </button> */}
                            <button
                              className="profile-btn logout-btn"
                              onClick={logOut}
                            >
                              Log Out
                            </button>
                          </div>
                        </>
                      )}
                      {/* <div className="language-section  ms-4"></div>
                    <div className="d-flex align-items-center gap-2 ">
                      <div
                        className="langWrap  d-flex align-items-center"
                        title="Select Language"
                      >
                        <FaLanguage
                          size={24}
                          className="language-icon"
                          color="#fff"
                        />
                        <select
                          className="lang-en lang-select ms-2"
                          ref={selectRef}
                          onChange={handleLanguageChange}
                          value={selectedLang}
                        >
                          <option value="en" className="notranslate">
                            English
                          </option>
                          <option value="hi" className="notranslate">
                            हिन्दी (Hindi)
                          </option>
                          <option value="bn" className="notranslate">
                            বাংলা (Bengali)
                          </option>
                          <option value="gu" className="notranslate">
                            ગુજરાતી (Gujarati)
                          </option>
                          <option value="kn" className="notranslate">
                            ಕನ್ನಡ (Kannada)
                          </option>
                          <option value="ml" className="notranslate">
                            മലയാളം (Malayalam)
                          </option>
                          <option value="mr" className="notranslate">
                            मराठी (Marathi)
                          </option>
                          <option value="ta" className="notranslate">
                            தமிழ் (Tamil)
                          </option>
                          <option value="te" className="notranslate">
                            తెలుగు (Telugu)
                          </option>
                          <option value="ur" className="notranslate">
                            اردو (Urdu)
                          </option>
                        </select>
                      </div>
                    </div> */}
                    </nav>
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
        </header>
      </>
    )
  );
}
